import http from '@core/fetch'
import { API_SETMEAL_LIST } from '@constant'

export default {
  setMealListApi: params =>
    http(API_SETMEAL_LIST, {
      body: params
    }), //普通套餐列表

  setMealListApi2: params =>
    http('/p/wedding/index.php/Admin/APISetMealRelation/allCaseList', {
      body: params
    }), //普通套餐列表

  add_relative_setmealApi: params =>
    http.post('/p/wedding/index.php/Admin/APIMerchantRecommendMeal/edit', {
      body: params
    }), //设置关联套餐
  up_seatApi: params =>
    http.post(' /p/wedding/index.php/Admin/APIMerchantRecommendMeal/up_seat', {
      body: params
    }), //上移
  deleteShowCaseApi: params =>
    http.post('/p/wedding/index.php/Admin/APIMerchantRecommendMeal/cancel', {
      body: params
    }), //取消推荐
  change_typeApi: () =>
    http.post(
      `/p/wedding/index.php/Admin/APIMerchantRecommendMeal/change_type`
    ),
  editApi: params =>
    http.post('/p/wedding/index.php/Admin/APIMerchantRecommendMeal/edit', {
      body: params
    }), //设置关联套餐
  getInfoApi: params =>
    http.get('/p/wedding/index.php/Admin/APIMerchantRecommendMeal/edit', {
      body: params
    }), //设置关联套餐

  getCaseListApi: params =>
    http('/hms/hljLocalserviceProduct/adminApi/merchant/caseList', {
      body: params
    }), //案例列表

  /* 婚礼服务相关接口 start */

  // 获取婚礼服务状态
  getWeddingService: body =>
    http.get('/hms/hljLocalserviceProduct/adminApi/service/services', { body }),

  // 获取定制婚礼服务-详情
  getCustomDetail: body =>
    http.get('/hms/hljLocalserviceProduct/adminApi/service/customer', { body }),

  // 删除定制婚礼服务-详情
  delCustomDetail: body =>
    http.post('/hms/hljLocalserviceProduct/adminApi/service/customer/delete', {
      body
    }),

  // 设置定制婚礼服务-设置/编辑
  setCustomDetail: body =>
    http.post(
      '/hms/hljLocalserviceProduct/adminApi/service/customer/addOrEdit',
      { body }
    ),

  // 获取外地婚礼服务-详情
  getNonlocalDetail: body =>
    http.get('/hms/hljLocalserviceProduct/adminApi/service/out', { body }),

  // 删除外地婚礼服
  delNonlocalDetail: body =>
    http.post('/hms/hljLocalserviceProduct/adminApi/service/out/delete', {
      body
    }),

  // 设置外地婚礼服-设置/编辑
  setNonlocalDetail: body =>
    http.post('/hms/hljLocalserviceProduct/adminApi/service/out/addOrEdit', {
      body
    })

  /* 婚礼服务相关接口 end */
}
